@if (spec$ | async; as spec) {
  <div class="layout-col full">
    <!-- Header Section -->
    <div class="layout-row">
      @if (embedded) {
        <div class="flex layout-row place-start-center gap-md p-lg">
          <ng-template
            [ngTemplateOutlet]="header"
            [ngTemplateOutletContext]="{ $implicit: spec }"
          ></ng-template>
        </div>
      } @else {
        <mat-toolbar elderTheme class="gap-md">
          <button mat-icon-button (click)="onClose($event)">
            <mat-icon>close</mat-icon>
          </button>
          <ng-template
            [ngTemplateOutlet]="header"
            [ngTemplateOutletContext]="{ $implicit: spec }"
          ></ng-template>
        </mat-toolbar>
      }
    </div>
    <!-- Content -->
    <div class="flex layout-col">
      <elder-basic-pane-layout class="flex">
        <!-- General -->
        <elder-pane>
          <elder-pane-header>
            <elder-pane-title>{{ 'context.general' | translate }}</elder-pane-title>
            <elder-pane-actions>
              <button mat-icon-button [disabled]="!mainFrm.form.valid" (click)="onSave($event)">
                <mat-icon>save</mat-icon>
              </button>
              <button mat-icon-button [matMenuTriggerFor]="menu" [disabled]="creationMode">
                <mat-icon>more_vert</mat-icon>
              </button>
              <mat-menu #menu="matMenu">
                <button mat-menu-item (click)="onDelete($event)" [disabled]="!deletionEnabled">
                  <mat-icon>delete</mat-icon>
                  <span>{{ 'actions.delete' | translate }}</span>
                </button>
              </mat-menu>
            </elder-pane-actions>
          </elder-pane-header>
          <elder-pane-content>
            <form #mainFrm="ngForm" class="flex layout-row gap-xl">
              <div class="flex layout-col">
                <!-- Identifications -->
                <elder-pane-subtitle>{{
                  'context.identification' | translate
                }}</elder-pane-subtitle>
                <div class="layout-col gap-md">
                  <!-- ID -->
                  <mat-form-field class="flex" subscriptSizing="dynamic">
                    <mat-label>{{ 'context.id' | translate }}</mat-label>
                    <input
                      matInput
                      name="id"
                      #idModel="ngModel"
                      required
                      disabled
                      placeholder="{{ 'context.id' | translate }}"
                      pattern="{{ idValidatorPattern }}"
                      [(ngModel)]="spec.id"
                    />
                    @if (idModel?.errors?.['required']) {
                      <mat-error>{{ 'validations.required' | translate }}</mat-error>
                    }
                  </mat-form-field>
                  <!-- name input field -->
                  <mat-form-field class="flex" subscriptSizing="dynamic">
                    <mat-label>{{ 'context.name' | translate }}</mat-label>
                    <input
                      matInput
                      name="name"
                      placeholder="{{ 'context.name' | translate }}"
                      [(ngModel)]="spec.name"
                    />
                    <mat-error elderValidationError></mat-error>
                  </mat-form-field>
                </div>
              </div>
              <div class="flex layout-col">
                <!-- Material matcher -->
                <elder-pane-subtitle>{{ 'materials.matcher' | translate }}</elder-pane-subtitle>
                <div class="layout-col gap-md">
                  <!-- material matcher input fields -->
                  <app-material-matcher-detail [matcher]="spec.matcher">
                  </app-material-matcher-detail>
                </div>
              </div>
              <div class="flex layout-col">
                <!-- configuration -->
                <elder-pane-subtitle>{{ 'settings.title' | translate }}</elder-pane-subtitle>
                <div class="layout-col gap-md">
                  <!-- serial number regex input field -->
                  <mat-form-field class="flex" subscriptSizing="dynamic">
                    <mat-label>{{ 'batchtracing.serial-number.regex' | translate }}</mat-label>
                    <input
                      matInput
                      name="serial-number-regex"
                      placeholder="{{ 'batchtracing.serial-number.regex' | translate }}"
                      [(ngModel)]="spec.serialNumber.regex"
                    />
                    <mat-error elderValidationError></mat-error>
                  </mat-form-field>
                  <!-- vendors input field -->
                  <mat-form-field subscriptSizing="dynamic">
                    <mat-label>{{ 'manufacturer.title' | translate }}</mat-label>
                    <elder-multi-select-chips
                      name="vendors"
                      appMultiVendorSelect
                      valueAsId
                      [(value)]="spec.vendors"
                      placeholder="{{ 'manufacturer.title' | translate }}"
                    >
                    </elder-multi-select-chips>
                    <mat-error elderValidationError></mat-error>
                  </mat-form-field>
                </div>
              </div>
            </form>
          </elder-pane-content>
        </elder-pane>
      </elder-basic-pane-layout>
    </div>
  </div>
}

<ng-template #header let-spec>
  @if (creationMode) {
    <span>
      {{ 'batchtracing.spec.new' | translate }}
    </span>
  } @else {
    <elder-header [header]="'batchtracing.title' | translate" [subheader]="'ID: ' + spec.id">
    </elder-header>
  }
</ng-template>
